<div class="material-datatables">
    <table id="datatables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
          <thead>
              <tr>

                <th class="disabled-sorting no-sort" style="width: 85px;">
                  <b>
                    <a class="btn btn-link btn-primary btn-just-icon" (click)="selectAll()">
                      <i class="fa {{checkAll() ? 'fa-check-square' : 'fa-square-o'}}" aria-hidden="true"></i>
                    </a>
                    <!-- <a *ngIf="bulk.length > 0" class="btn btn-link btn-default btn-just-icon" title="Clean Selected" (click)="cleanBulk()">
                      <i class="material-icons">cleaning_services</i>
                    </a> -->
                  </b>
                </th>

                <th>{{ tableContactForm.headerRow[0] }}</th>
                <th>{{ tableContactForm.headerRow[1] }}</th>
                <th>{{ tableContactForm.headerRow[2] }}</th>
                <th>{{ tableContactForm.headerRow[3] }}</th>
                <th>{{ tableContactForm.headerRow[4] }}</th>
                <th>{{ tableContactForm.headerRow[5] }}</th>
                <th>{{ tableContactForm.headerRow[6] }}</th>

                <th>Rep</th>

                <!-- <th>Description</th> -->
                <th class="disabled-sorting text-right">Actions</th>
              </tr>
          </thead>
          <tfoot>
              <tr>

                <td style="width: 30px;"></td>

                <th>{{ tableContactForm.footerRow[0] }}</th>
                <th>{{ tableContactForm.footerRow[1] }}</th>
                <th>{{ tableContactForm.footerRow[2] }}</th>
                <th>{{ tableContactForm.footerRow[3] }}</th>
                <th>{{ tableContactForm.footerRow[4] }}</th>
                <th>{{ tableContactForm.footerRow[5] }}</th>
                <th>{{ tableContactForm.footerRow[6] }}</th>

                <th>Rep</th>

                <!-- <th>Description</th> -->
                <th class="text-right">Actions</th>
              </tr>
          </tfoot>
          <tbody>
              <tr *ngFor="let row of tableContactForm.dataRows">

                <td style="width: 30px;">
                  <a class="btn btn-link btn-info btn-just-icon" (click)="selectItem(row[0])">
                    <i class="material-icons">{{check(row[0]) ? 'check_box' : 'check_box_outline_blank'}}</i>
                  </a>
                </td>

                  <td>{{row[0]}}</td>
                  <td>{{row[1]}}</td>
                  <td>{{row[9]}}</td>
                  <td>{{row[2]}}</td>
                  <td>{{row[3]}}</td>
                  <td>{{row[4]}}</td>
                  <td>{{row[5] * 1000 | date:'MM/dd/yyyy' }}</td>

                  <td *ngIf="row[8] !== ''">
                     {{row[7]}} &nbsp;
                     <button *ngIf="assigned" class="btn btn-danger btn-sm" id="{{row[0]}}-unassigned" (click)="saveEmit('unassigned',row[0])" title="Unassignedag">
                       <i class="material-icons emitir">not_interested</i>
                      </button>
                  </td>

                  <td *ngIf="row[8] === '' && row[10] !== 'BLACKLISTED'">
                    <button class="btn btn-warning btn-sm emitir" id="{{row[0]}}-assigned" (click)="saveEmit('assigned',row[0], row[8])" title="Assign">
                      Assign to
                    </button>
                  </td>

                  <td *ngIf="row[8] === '' && row[10] === 'BLACKLISTED'">
                    Blacklisted <br>
                    <button *ngIf="assigned" class="btn btn-danger btn-sm" id="{{row[0]}}-unblack" (click)="saveEmit('unblack',row[0])" title="Unblack">
                       <i class="material-icons emitir">not_interested</i>
                      </button>
                  </td>

                  <td class="text-right">
                    <a *ngIf="!blacklist" class="btn btn-link btn-danger btn-just-icon" (click)="saveEmit('banear',row[0], row[3])" title="Send to Black List" style="margin: -5px, -5px, -5px, -5px">
                      <i class="material-icons emitir" id="{{row[0]}}-banear">block</i>
                    </a>
                    <a  class="btn btn-link btn-info btn-just-icon" title="Detail">
                      <i class="material-icons emitir" id="{{row[0]}}-show">remove_red_eye</i>
                    </a>

                    <a class="btn btn-link btn-danger btn-just-icon remove" (click)="deleteContact(row[0])" title="Remove">
                      <i class="material-icons emitir" id="{{row[0]}}-remove">close</i>
                    </a>
                  </td>

              </tr>
          </tbody>
      </table>
  </div>